// NO EDITAR A MANO
import {TraduccionLiteral} from "services-comun/modules/traduccion/literal";

import type {FooterCopyrightParams} from "../../../footer";

const id = "footer.copyright";
const params: string[] = ["anno"];
const valor = `© {{anno}} Meteored. All rights reserved`;

export default new TraduccionLiteral<FooterCopyrightParams>({
    id,
    params,
}, valor);
